import React from 'react';
import { ExplanationLink } from './styles';
import { User } from '@vette/data-access';
import { env } from '@vette/common-utils';
import { Text } from '../../common/atoms/Typography';
import { Space } from '../../common/atoms/Space';
import { theme } from '../../common/theme';

type Props = {
  isPredemo?: boolean;
  vetter?: VetterInfo;
  timerNode?: React.ReactNode;
  interviewNowButtonText?: string;
  interviewNowButtonLookingForVetter?: string;
};

const TWILIO_PHONE_NUMBER = env.checkEnvVarValue(
  process.env.NEXT_PUBLIC_TWILIO_PHONE_NUMBER
);

const EXPLANATIONS = {
  INTERVIEW_NOW: ({ isPredemo, interviewNowButtonText }: Props) => (
    <>
      This call may be recorded for quality and training purposes. By clicking
      &quot;
      {isPredemo
        ? 'Connect Now'
        : interviewNowButtonText
        ? interviewNowButtonText
        : 'Interview Now'}
      &quot; you accept the{' '}
      <ExplanationLink href="/terms" target="__blank">
        terms and conditions
      </ExplanationLink>{' '}
      and{' '}
      <ExplanationLink href="/privacy" target="__blank">
        privacy policy
      </ExplanationLink>
      .
    </>
  ),
  INTERVIEWING: ({ isPredemo }: Props) =>
    `${
      isPredemo ? "We'll be" : 'Your interviewer will be'
    } calling you shortly, please make sure your phone is not on "do not disturb".\nGood luck you've got this!`,
} as const;

export type VetterInfo =
  | Pick<User, 'firstName' | 'photoLowUrl'>
  | null
  | undefined;

export const stateCopy = {
  disabled: {
    explanation: EXPLANATIONS.INTERVIEW_NOW,
    text: ({ isPredemo, interviewNowButtonText }: Props) =>
      isPredemo
        ? 'Connect Now'
        : interviewNowButtonText
        ? interviewNowButtonText
        : 'Interview Now',
  },
  enabled: {
    explanation: EXPLANATIONS.INTERVIEW_NOW,
    text: ({ isPredemo, interviewNowButtonText }: Props) =>
      isPredemo
        ? 'Connect Now'
        : interviewNowButtonText
        ? interviewNowButtonText
        : 'Interview Now',
  },
  'looking-for-vetter': {
    explanation: EXPLANATIONS.INTERVIEWING,
    text: ({ isPredemo, interviewNowButtonLookingForVetter }: Props) =>
      isPredemo
        ? 'Hang tight, get comfortable while we connect you to Vette…'
        : interviewNowButtonLookingForVetter ||
          'Hang tight, get comfortable while we search for your interviewer…',
  },
  'found-vetter': {
    explanation: EXPLANATIONS.INTERVIEWING,
    text: ({ vetter, timerNode }: Props) => (
      <Space direction="vertical" size={12}>
        <Text $size={15} $color={theme.colors.white} $weight={400}>
          {vetter?.firstName} will be calling
          <br />
          <Text $size={15} $color={theme.colors.white} $weight={800}>
            in {timerNode} seconds...
          </Text>
        </Text>
        <Text $size={15} $color={theme.colors.white} $weight={400}>
          {TWILIO_PHONE_NUMBER}
        </Text>
      </Space>
    ),
  },
};
